document.addEventListener('DOMContentLoaded', function() {
  const addonsWrapper = document.querySelector('.hdt-product-addons-wrapper');
  if (!addonsWrapper) return;

  const checkboxes = addonsWrapper.querySelectorAll('.hdt-addon-checkbox');
  const mainForm = document.querySelector('form[action*="/cart/add"]');
  const atcButton = mainForm ? mainForm.querySelector('button[name="add"]') : null;
  const atcTextSpan = atcButton ? atcButton.querySelector('span:not(.hdt-loading__spinner)') : null;
  
  // Save original ATC text and create total span
  let originalAtcText = atcTextSpan ? atcTextSpan.innerHTML : '';
  let totalSpan = document.createElement('span');
  totalSpan.className = 'hdt-atc-addon-total';
  
  if (atcTextSpan) {
    atcTextSpan.appendChild(totalSpan);
  }

  function getCheckedAddons() {
    return Array.from(checkboxes).filter(cb => cb.checked);
  }

  function updateTotalDisplay() {
    if (!atcTextSpan) return;
    
    const checkedAddons = getCheckedAddons();
    
    // If no addons checked, restore original text
    if (checkedAddons.length === 0) {
      totalSpan.innerHTML = '';
      return;
    }

    // Get current main product price
    // Note: Ecomus might update this price elsewhere. We can try to grab it dynamically 
    // or just show the extra price like "(+ 300 EGP)"
    let extraPrice = 0;
    checkedAddons.forEach(cb => {
      extraPrice += Number(cb.dataset.price) || 0;
    });

    // Format money (basic format, relies on Shopify liquid formatting normally, 
    // but here we just append the store currency)
    // For a robust implementation, theme's formatMoney could be used.
    if (typeof window.formatMoney === 'function') {
      totalSpan.innerHTML = '(+ ' + window.formatMoney(extraPrice) + ')';
    } else {
      totalSpan.innerHTML = '(+ ' + (extraPrice / 100).toFixed(2) + ')';
    }
  }

  // Listen for checkbox changes
  checkboxes.forEach(cb => {
    cb.addEventListener('change', updateTotalDisplay);
  });

  // Intercept the main form submission
  if (mainForm) {
    mainForm.addEventListener('submit', function(e) {
      const checkedAddons = getCheckedAddons();
      
      // If no addons checked, let the native form submission or theme's AJAX cart handle it
      if (checkedAddons.length === 0) {
        return;
      }

      // We have add-ons! Intercept submission to add everything together.
      e.preventDefault();
      e.stopImmediatePropagation();
      
      // Add loading state to button
      if (atcButton) {
        atcButton.classList.add('loading');
        atcButton.disabled = true;
      }

      // Gather items
      const items = [];
      
      // 1. Main product
      const mainIdInput = mainForm.querySelector('[name="id"]');
      const mainQtyInput = mainForm.querySelector('[name="quantity"]');
      if (mainIdInput) {
        items.push({
          id: mainIdInput.value,
          quantity: mainQtyInput ? parseInt(mainQtyInput.value) || 1 : 1
        });
      }

      // 2. Add-ons
      checkedAddons.forEach(cb => {
        items.push({
          id: cb.value,
          quantity: 1 // Add-ons are typically added as 1 unit
        });
      });

      // Submit via AJAX Cart API
      fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => response.json())
      .then(data => {
        // Trigger Ecomus theme cart reload
        document.dispatchEvent(new CustomEvent('cart:reload'));
        
        // Remove loading state
        if (atcButton) {
          atcButton.classList.remove('loading');
          atcButton.disabled = false;
        }
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        if (atcButton) {
          atcButton.classList.remove('loading');
          atcButton.disabled = false;
        }
      });
    }, { capture: true });
  }
});
